import { FC } from 'react';
import classNames from 'classnames';

import { Membership, SubscriptionDetailsv4, SubscriptionPackage } from '@bpm-web-app/supreme-api-sdk';
import { formatDateToString } from '@bpm-web-app/utils';
import { useGetSubscriptionPackage } from '@bpm-web-app/swr-hooks';
import styles from './your-plan.module.css';

type Props = {
    membership?: Membership;
};

const getDiscountValue = (membership: Membership) => {
    const fullAmount = Number(membership.subscription?.package?.amount) * 100;
    const discountAmount = Number(membership.discounted?.amount) * 100;
    const discount = (fullAmount - discountAmount) / 100;
    const rounded = Math.floor(discount * 100) / 100;
    return rounded.toString().endsWith('.00') ? Math.floor(rounded) : rounded;
};

export const StatusNote: FC<Props> = ({ membership }) => {
    const { data: downgradeData } = useGetSubscriptionPackage(membership?.subscription?.next_cycle_package_change);

    if (membership?.has_membership && membership?.subscription?.status === SubscriptionDetailsv4.StatusEnum.Cancelled && membership.subscription.next_cycle_package_change) {
        const theme = (downgradeData?.data.library === SubscriptionPackage.LibraryEnum.All ? 'all' : downgradeData?.data?.name ?? '').toString().toLowerCase();

        return (
            <p className={classNames(styles['plan__status-note'], styles['plan__status-note--neutral'])}>
                Changes{' '}
                {!!downgradeData && (
                    <>
                        to{' '}
                        <span
                            style={
                                {
                                    '--color-subscription': `var(--color-subscription-${theme})`,
                                } as React.CSSProperties
                            }
                        >
                            {downgradeData.data.display_title || downgradeData?.data.name}
                        </span>
                    </>
                )}{' '}
                on {formatDateToString(membership.subscription.expire_date, 'L')}
            </p>
        );
    }

    if (membership?.has_membership && membership?.subscription?.status === SubscriptionDetailsv4.StatusEnum.Cancelled) {
        return <p className={classNames(styles['plan__status-note'], styles['plan__status-note--cancelled'])}>Cancels on {formatDateToString(membership.subscription.expire_date, 'L')}</p>;
    }

    if (membership?.discounted) {
        return (
            <p className={styles['plan__status-note']}>
                *${getDiscountValue(membership)} discount ends on {formatDateToString(membership.discounted.until, 'L')}
            </p>
        );
    }

    if (!membership?.is_paused && membership?.paused_until) {
        return (
            <p className={classNames(styles['plan__status-note'], styles['plan__status-note--paused'])}>Pauses on {formatDateToString(membership.subscription?.expire_date, 'L')}</p>
        );
    }

    if (membership?.is_paused && membership.paused_until) {
        return <p className={classNames(styles['plan__status-note'], styles['plan__status-note--paused'])}>Resumes on {formatDateToString(membership.paused_until, 'L')}</p>;
    }

    return null;
};
